// The rule every staff reason follows: no emails (the erasure API refuses a reason that looks
// like one, packages/accounts EMAIL_LIKE); the ticket number is enough.
export const EMAIL_LIKE = /[^\s@]+@[^\s@]+\.[^\s@]+/

export const looksLikeEmail = (reason: string): boolean => EMAIL_LIKE.test(reason)
